<ng-container *ngIf="isVisible">

<!-- Floating toggle button -->
<button
  class="ai-chat-toggle"
  [class.ai-chat-toggle--hidden]="isOpen"
  [class.ai-chat-toggle--rtl]="isRtl"
  (click)="toggleChat()"
  [attr.aria-label]="isOpen ? 'Close assistant' : 'Open assistant'"
>
  <app-atlas-ai-logo></app-atlas-ai-logo>
</button>

<!-- Chat panel -->
<div
  class="ai-chat-panel"
  [class.ai-chat-panel--open]="isOpen"
  [class.ai-chat-panel--rtl]="isRtl"
  [attr.dir]="isRtl ? 'rtl' : 'ltr'"
>

  <!-- Header -->
  <div class="ai-chat-header">
    <div class="ai-chat-header__title">
      <img src="assets/images/icon-atlas.svg" alt="Atlas" width="24" height="24" />
      <span>{{ 'Atlas Virtual Assistant' | transloco }}</span>
      <span class="ai-chat-header__beta">BETA</span>
    </div>
    <button *ngIf="!isStartPage" class="ai-chat-header__new" (click)="clearChat(); $event.stopPropagation()" title="New conversation">↺</button>
    <button class="ai-chat-header__close" (click)="toggleChat()">✕</button>
  </div>

  <!-- Start page (shown before first message) -->
  <div class="ai-chat-start" *ngIf="isStartPage">
    <p class="ai-chat-start__greeting">
      <ng-container *ngIf="userName">{{ 'Hi' | transloco }} {{ userName }}</ng-container>
      <ng-container *ngIf="!userName">{{ 'Hi there' | transloco }}</ng-container>
      👋 {{ "I'm your grant discovery assistant." | transloco }}
    </p>
    <p class="ai-chat-start__body">{{ 'Tell me about the project you\'re trying to fund, and I\'ll help search for relevant funding sources.' | transloco }}</p>
    <p class="ai-chat-start__body">{{ 'After you describe your project, I\'ll identify the most relevant search criteria and look for matching grant opportunities.' | transloco }}</p>
    <p class="ai-chat-start__question">{{ 'What project are you raising funds for?' | transloco }}</p>
  </div>

  <!-- Messages area (shown after first message) -->
  <div class="ai-chat-messages" *ngIf="!isStartPage" #messagesContainer>
    <div
      *ngFor="let msg of displayMessages"
      class="ai-chat-message"
      [class.ai-chat-message--user]="msg.role === 'user'"
      [class.ai-chat-message--assistant]="msg.role === 'assistant'"
    >
      <img
        *ngIf="msg.role === 'assistant'"
        src="assets/images/icon-atlas.svg"
        alt="Atlas"
        class="ai-chat-message__avatar"
        width="28"
        height="28"
      />
      <div
        class="ai-chat-message__bubble"
        [class.ai-chat-message__bubble--editable]="msg.role === 'user'"
        [title]="msg.role === 'user' ? ('Click to edit' | transloco) : ''"
        (click)="msg.role === 'user' && editMessage(msg.content)"
      >
        {{ msg.content }}
        <span *ngIf="msg.role === 'user'" class="ai-chat-message__resend-hint">↩</span>
      </div>
    </div>

    <!-- Search criteria summary -->
    <div *ngIf="pendingSearch && !isLoading" class="ai-chat-criteria">
      <p class="ai-chat-criteria__title">{{ "I'll use these search criteria:" | transloco }}</p>
      <div *ngIf="pendingSearchInterests.length" class="ai-chat-criteria__row">
        <span class="ai-chat-criteria__label">{{ 'Category' | transloco }}:</span>
        <span class="ai-chat-criteria__value">{{ pendingSearchInterests.join(', ') }}</span>
      </div>
      <div class="ai-chat-criteria__row">
        <span class="ai-chat-criteria__label">{{ 'Type' | transloco }}:</span>
        <span class="ai-chat-criteria__value">{{ pendingFundTypesDisplay }}</span>
      </div>
      <div *ngIf="pendingLocationDisplay && pendingSearchType !== 'FUND_NAME' && pendingSearchType !== 'FUND_PEOPLE' && pendingSearchType !== 'SUPPORTED_ORGANIZATIONS'" class="ai-chat-criteria__row">
        <span class="ai-chat-criteria__label">{{ 'Geographical Area of Activity' | transloco }}:</span>
        <span class="ai-chat-criteria__value">{{ pendingLocationDisplay }}</span>
      </div>
      <div *ngIf="pendingSearch.freeText" class="ai-chat-criteria__row">
        <span class="ai-chat-criteria__label">
          <ng-container *ngIf="pendingSearchType === 'FUND_NAME'">{{ 'Fund name' | transloco }}</ng-container>
          <ng-container *ngIf="pendingSearchType === 'FUND_PEOPLE'">{{ 'Contact person' | transloco }}</ng-container>
          <ng-container *ngIf="pendingSearchType === 'SUPPORTED_ORGANIZATIONS'">{{ 'Supported organization' | transloco }}</ng-container>
          <ng-container *ngIf="pendingSearchType !== 'FUND_NAME' && pendingSearchType !== 'FUND_PEOPLE' && pendingSearchType !== 'SUPPORTED_ORGANIZATIONS'">{{ 'Free Text Search' | transloco }}</ng-container>
        </span>:
        <span class="ai-chat-criteria__value">{{ pendingSearch.freeText }}</span>
      </div>
    </div>

    <!-- Pending search action button -->
    <div *ngIf="pendingSearch && !isLoading" class="ai-chat-action">
      <button class="ai-chat-action__btn" (click)="performPendingSearch()">
        {{ 'Looks good, perform search' | transloco }}
      </button>
    </div>

    <!-- Typing indicator -->
    <div *ngIf="isLoading" class="ai-chat-message ai-chat-message--assistant">
      <img src="assets/images/icon-atlas.svg" alt="Atlas" class="ai-chat-message__avatar" width="28" height="28" />
      <div class="ai-chat-message__bubble ai-chat-message__bubble--typing">
        <span></span><span></span><span></span>
      </div>
    </div>
  </div>

  <!-- Input area -->
  <div class="ai-chat-input">
    <div class="ai-chat-input__card">
      <textarea
        #inputTextarea
        [formControl]="inputControl"
        [placeholder]="inputPlaceholder"
        (keydown)="onKeydown($event)"
        [disabled]="isLoading"
      ></textarea>
      <button
        class="ai-chat-input__send"
        (click)="sendMessage()"
        [disabled]="isLoading || !inputControl.value?.trim()"
      >
        {{ 'Send' | transloco }}
      </button>
    </div>
  </div>

</div>

</ng-container>
